import vi from "./vi";
import en from "./en";
import ja from "./ja";

let lang;
function locales(locale = "vi"){
    switch (locale){
        case 'vi':
            lang = vi
            break;
        case 'en':
            lang = en
            break;
        case 'ja':
            lang = ja
            break;
        default:
            lang = vi
    }
    return lang;
}

export default locales;


// WEBPACK FOOTER //
// ./resources/build/js/locales/locales.js